import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { axiosClient } from '../axios';
import { PATHS } from '../constants';
import { DocumentCategory, Scalars, useCreateDocumentMutation } from '../types/api.graphql';

export const useGenerateRiskReport = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [createDocument] = useCreateDocumentMutation();

  const handleDocumentCreation = async (organizationId: Scalars['ID']): Promise<Scalars['ID']> => {
    const oneYearFromToday = new Date();
    oneYearFromToday.setFullYear(oneYearFromToday.getFullYear() + 1);

    const response = await createDocument({
      variables: {
        documentParams: {
          organizationIds: [organizationId],
          category: DocumentCategory.RiskReport,
          documentUrl: '',
          expiresAt: oneYearFromToday.toISOString(),
          title: t('riskReport'),
        },
      },
    });

    return response?.data?.createDocument?.id;
  };

  const generateRiskReport = async (selectedOrgId: Scalars['ID']) => {
    const riskReportDocumentId = await handleDocumentCreation(selectedOrgId);

    await axiosClient.get(`riskReport-pdf/${selectedOrgId}/${riskReportDocumentId}`, {
      responseType: 'arraybuffer',
    });

    navigate(PATHS.Documents.Uploads.Details(riskReportDocumentId));
  };

  return { generateRiskReport };
};
